<template>
    <div class="d-flex align-items-center">
        <template v-if="attachments.length">
            <div class="cursor-pointer" @click.prevent="openModal">
                <app-avatars-group
                    :avatar-group-class="avatarGroupClass"
                    :avatars="avatars"
                    :border="true"
                    :shadow="true"
                    :skip-check="true"
                    :style="{pointerEvents: 'none'}"
                />
            </div>
        </template>
        <span v-else>{{ emptyText }}</span>

        <modal v-if="isModalActive"
               :id="modalId"
               size="large"
               v-model="isModalActive"
               :title="modalTitle"
               :hideFooter="true">
            <div v-if="normalizedFiles.length" class="file-preview-grid">
                <div v-for="(file, index) in normalizedFiles" :key="`${file.url}-${index}`" class="file-preview-item">
                    <img v-if="isImage(file.url)"
                         class="img-fluid img-thumbnail mb-2"
                         :src="file.url"
                         :alt="file.name">
                    <div v-else class="file-placeholder img-thumbnail mb-2">
                        <i :class="fileIconClass(file.url)"></i>
                    </div>
                    <div class="text-truncate small mb-2" :title="file.name">{{ file.name }}</div>
                    <button type="button" class="btn btn-sm btn-primary" @click="viewFile(file.url)">
                        {{ $t('view') }}
                    </button>
                </div>
            </div>
            <p v-else class="mb-0 text-muted">{{ emptyText }}</p>
        </modal>
    </div>
</template>

<script>
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import {urlGenerator} from "../../../common/Helper/AxiosHelper";

export default {
    name  : "AppFilePreviewGroup",
    mixins: [HelperMixin],
    props : {
        value  : {},
        data   : {
            type   : Object,
            default: () => ({})
        },
        rowData: {
            type   : Object,
            default: () => ({})
        },
        tableId: {},
    },
    data() {
        return {
            isModalActive   : false,
            avatarGroupClass: 'avatars-group-w-50',
        }
    },
    computed: {
        attachments() {
            return Array.isArray(this.value) ? this.value : [];
        },
        normalizedFiles() {
            return this.attachments.map((fileUrl, index) => ({
                url : urlGenerator(fileUrl),
                name: this.fileTitle(fileUrl, index)
            }));
        },
        avatars() {
            return this.normalizedFiles.map((file, index) => ({
                img     : this.isImage(file.url) ? file.url : null,
                alt     : `${this.previewLabel} ${index + 1}`,
                title   : file.name,
                subTitle: this.previewLabel
            }));
        },
        previewLabel() {
            return this.data.label || this.$t('attachments');
        },
        emptyText() {
            return this.data.emptyText || '-';
        },
        modalTitle() {
            return this.data.modalTitle || this.previewLabel;
        },
        modalId() {
            const suffix = this.rowData && this.rowData.id ? this.rowData.id : 'preview';
            return `file-preview-modal-${suffix}`;
        }
    },
    methods: {
        openModal() {
            this.isModalActive = true;
        },
        fileTitle(fileUrl, index) {
            if (!fileUrl) {
                return `${this.previewLabel} ${index + 1}`;
            }

            const sanitizedUrl = fileUrl.split('?')[0];
            const parts = sanitizedUrl.split('/');
            const name = parts[parts.length - 1];

            return name || `${this.previewLabel} ${index + 1}`;
        },
        fileIconClass(url) {
            const extension = this.getFileExtension(url).replace('.', '') || 'alt';
            return `fa fa-file-${extension}`;
        }
    }
}
</script>

<style scoped lang="scss">
.file-preview-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 1rem;
}

.file-preview-item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

.file-placeholder {
    min-height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 3rem;
    color: #6c757d;
    background-color: #f8f9fa;
}
</style>
